export default __webpack_public_path__ + "static/media/Luna.0118f13c.jpg";